// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.mjs";

function execute(json) {
  return {
          external_id: Json_decode.at({
                  hd: "order_interest",
                  tl: {
                    hd: "external_id",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        };
}

export {
  execute ,
}
/* No side effect */
